$(document).on('click', '.hidden-link:not(a)', function() {
    const elem = $(this)
    const href = elem.data('link')
    const text = elem.find('.text')

    text.text(href)
    elem.replaceWith($('<a href="' + href + '" class="hidden-link show">' + elem.html() + '</a>'))
})